import { PORTAL_TIER_PRICES_ACTIONS } from './portalTierPrices.types'

/**
 * @param {Object.<string, import('./portalTierPrices.types').PortalTierPrice>} payload
 * @returns {Object}
 */
export const setPortalTierPricesAction = payload => ({
  type: PORTAL_TIER_PRICES_ACTIONS.SET_PORTAL_TIER_PRICES,
  payload
})

/**
 * @param {import('./portalTierPrices.types').PortalTierPrice} payload
 * @returns {Object}
 */
export const setPortalTierPriceAction = payload => ({
  type: PORTAL_TIER_PRICES_ACTIONS.SET_PORTAL_TIER_PRICE,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setPortalTierPricesStatusAction = payload => ({
  type: PORTAL_TIER_PRICES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setPortalTierPricesErrorsAction = payload => ({
  type: PORTAL_TIER_PRICES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearPortalTierPricesErrorsAction = () => ({
  type: PORTAL_TIER_PRICES_ACTIONS.CLEAR_ERRORS
})
